<template>
    <div class="d-flex justify-content-center button-container">
        <span v-if="isPlaying"
              v-on:click="listen"
              class="player-button pause-button d-inline-block"
        >
        </span>
        <span v-else
              v-on:click="listen"
              class="player-button play-button d-inline-block"
        ></span>
    </div>
</template>

<script>
import {RadioPlayerInstance} from '@/App.vue'

export default {
  name: 'PlayerButtonSmallWithoutLabel',
  data () {
    return {
      isPlaying: false
    }
  },
  created () {
    this.isPlaying = RadioPlayerInstance.getIsPlaying()
  },
  methods: {
    listen () {
      if (this.isPlaying) {
        RadioPlayerInstance.pause()
      } else {
        RadioPlayerInstance.play()
      }
      this.isPlaying = !this.isPlaying
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "compass/css3";
  @import "../../common.scss";

  $button-size: 40px;

  .player-button {
    @include background-size($button-size $button-size !important);
    width: $button-size;
    height: $button-size;
    cursor: pointer;
  }
  .play-button {
    background: url(./play.svg);

  }
  .pause-button {
    background: url(./pause.svg);
  }
  .button-block {
    align-items: center;
  }
  .button-container {
    padding: 6px;
    align-items: center;
    background-color: orange;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }
  .song-title {
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlayerButtonSmall/PlayerButtonSmallWithoutLabel.vue